<template>
    <div>
        <el-form :inline="true" :model="searchForm" @submit.native.prevent>
            <el-form-item label="ICCID号：">
                <el-input v-model.trim="searchForm.iccid" @keyup.enter.native="getAddressListHandler" clearable></el-input>
            </el-form-item>
            <el-form-item label="省份：">
                <el-input v-model.trim="searchForm.province" @keyup.enter.native="getAddressListHandler" clearable></el-input>
            </el-form-item>

            <el-form-item>
                <el-button type="primary" @click="getAddressListHandler">搜 索</el-button>
                <el-button type="primary"  @click="exportSimWxAddressHandle()">导 出</el-button>
            </el-form-item>
        </el-form>

        <el-table :data="tbpg.tableData" border  >
            <el-table-column type="index" label="序号"></el-table-column> 
            <el-table-column label="ICCID号" width="160">
                <template slot-scope="scope">
                    <a href="javascript:void(0)" @click="goToDetailPage(scope.row)">{{ scope.row.iccid }}</a>
                </template>
            </el-table-column>
            <el-table-column  prop="intoNo" label="接入号"></el-table-column>
            <el-table-column  prop="country" label="地区"></el-table-column>
            <el-table-column  prop="province" label="省"></el-table-column>
            <el-table-column  prop="city" label="市"></el-table-column>
            <el-table-column  prop="supplierName" label="运营商"></el-table-column>
            <el-table-column  prop="agentPathNames" label="代理商层级关系"></el-table-column>

        </el-table>
        
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tbpg.currentPage"
            :page-sizes="[15, 50, 100, 500]"
            :page-size="tbpg.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tbpg.total">
        </el-pagination>

                 
    </div>
</template>
<script>
import { getAddressList} from '@/api/record.js'
import { exportSimWxAddress} from '@/api/sim.js'
import common from '@/utils/common.js'
export default {
    data(){
        return {
            searchForm: {
                iccid: '',
                province: '',
            },
            tbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0
            },
        }
    },
    methods: {

        getAddressListHandler($event){
            common.resetCurrentPage(this, $event, 'tbpg');
            var data = common.getRequestParams(this, 'tbpg', this.searchForm);   
            getAddressList(data).then(res => {
                common.listCallback(this, res, 'tbpg');
            })   

        },

        goToDetailPage(row){
            this.$store.commit('menu/setFromPage', 'cardMgt');
            this.$store.commit('menu/setFromPageIccid', row.iccid);
            document.getElementById('cardDetailsMenu').click();
        },

        exportSimWxAddressHandle(){//导出excel文件
            this.$confirm("您确定要导出数据吗？", "提示" ,{          
                confirmButtonText: '确 定',
                cancelButtonText: '取 消'
            }).then(() => {
                exportSimWxAddress(this.searchForm).then(res =>{
                    if(res.data.code == 200){
                        this.$message.success('数据导出中,请稍候去下载专区下载');
                    }else{
                        this.$message.error(res.data.msg);
                    }
                }).catch(err=>console.error(err));
            }).catch(() => {
                
            });
        },

      
        handleSizeChange(val){
            this.tbpg.pageSize = val;
            this.getAddressListHandler();
        },
        handleCurrentChange(val){
            this.tbpg.currentPage = val;
            this.getAddressListHandler();
        }  
    },
    created () {
        this.getAddressListHandler()
    }
}
</script>
<style lang="less" scoped>

</style>

